import { c as _c } from "react/compiler-runtime";
import { Formik } from 'formik';
import { useContext } from 'react';
import { useTheme } from 'styled-components';
import { getMFASetupUrl } from '../../../../../client/Hookdeck';
import { StyledCard } from '../../../../common/base/Card';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import { StyledRadioCard } from '../../../../common/Form/Fields/RadioCardsInput';
import SwitchInput from '../../../../common/Form/Fields/SwitchInput';
import TextInput from '../../../../common/Form/Fields/TextInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import Modal from '../../../../common/Modal';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { DashboardContext } from '../../DashboardContext';
import { APITeam, ProjectTypeInput } from '../../../../../../../../typings/Team.interface';
import { useHistory } from 'react-router';
const NewTeamModal: React.FC<{
  organization_id: string;
  onClose: () => void;
  onSuccess: (team: APITeam) => void;
}> = t0 => {
  const $ = _c(21);
  const {
    organization_id,
    onClose,
    onSuccess
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  const {
    organizations,
    team
  } = useContext(DashboardContext);
  const theme = useTheme();
  let t1;
  if ($[0] !== organization_id || $[1] !== organizations) {
    t1 = organizations?.find(o => o.id === organization_id)?.role;
    $[0] = organization_id;
    $[1] = organizations;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const organization_role = t1;
  useHistory();
  const is_admin = organization_role === "admin" || organization_role === "owner";
  let t2;
  if ($[3] !== HookdeckAPI.teams || $[4] !== addToast || $[5] !== is_admin || $[6] !== onSuccess || $[7] !== organization_id) {
    t2 = v => {
      HookdeckAPI.teams.create({
        name: v.name,
        private: is_admin ? v.private : true,
        organization_id,
        type: v.type
      }).then(team_0 => {
        addToast("success", `Project ${v.name} created`);
        onSuccess(team_0);
      }).catch(error => {
        const mfa_setup_url = getMFASetupUrl(error);
        if (mfa_setup_url) {
          window.location.assign(mfa_setup_url);
          return;
        }
        addToast("error", error?.response?.data?.message || "Failed to create the project, please contact us.");
      });
    };
    $[3] = HookdeckAPI.teams;
    $[4] = addToast;
    $[5] = is_admin;
    $[6] = onSuccess;
    $[7] = organization_id;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const onSubmit = t2;
  const t3 = is_admin ? false : true;
  const t4 = (team?.type === "outpost" ? "outpost" : "event_gateway") as ProjectTypeInput;
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = {
      name: "",
      private: t3,
      type: t4
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== is_admin || $[13] !== onClose || $[14] !== theme.colors.surface.base.surface || $[15] !== theme.mode) {
    t6 = props => <form onSubmit={props.handleSubmit}><Modal portal={true} title="Create new project" size="large" cancel_label="Cancel" hide_close={true} submit_label="Create project" onSubmit={props.handleSubmit} submit_disabled={props.isSubmitting || !props.dirty || !props.isValid} submit_icon={props.isSubmitting ? "loading" : "add_circle"} onCancel={onClose} onClose={onClose}><Text as="p" m={{
          b: 4
        }}>Projects house connections, routing logic, and event history.</Text><TextInput name="name" label="Project name" required={true} focus={true} /><Div m={{
          b: 6
        }}><Text semi={true} size="xs" muted={true} m={{
            b: 2
          }}>Project type</Text><Div grid={{
            columns: 2,
            gap: 2
          }} role="radiogroup"><StyledRadioCard as="label" checked={props.values.type === "event_gateway"} style={{
              backgroundColor: theme.colors.surface.base.surface
            }} flex={{
              direction: "column"
            }}><Div flex={{
                align: "flex-start",
                gap: 3
              }} p={4}><input style={{
                  marginTop: "1px"
                }} type="radio" name="type" value="event_gateway" checked={props.values.type === "event_gateway"} onChange={() => props.setFieldValue("type", "event_gateway")} /><Div flex={{
                  direction: "column",
                  gap: 1,
                  grow: true
                }}><Text semi={true}>Event Gateway</Text><Text muted={true} size="m" align="left">Handle events from external providers before they hit your application.</Text></Div></Div><Div flex={true} p={{
                x: 2,
                b: 2
              }}><StyledCard overflow_hidden={true} flex={{
                  align: "center",
                  justify: "center"
                }}><img src={`/images/usecase-receive-${theme.mode}.png`} alt="Event Gateway" style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain"
                  }} /></StyledCard></Div></StyledRadioCard><StyledRadioCard as="label" checked={props.values.type === "outpost"} style={{
              backgroundColor: theme.colors.surface.base.surface
            }} flex={{
              direction: "column"
            }}><Div flex={{
                align: "flex-start",
                gap: 3
              }} p={4}><input style={{
                  marginTop: "1px"
                }} type="radio" name="type" value="outpost" checked={props.values.type === "outpost"} onChange={() => props.setFieldValue("type", "outpost")} /><Div flex={{
                  direction: "column",
                  gap: 1,
                  grow: true
                }}><Text semi={true}>Outpost</Text><Text muted={true} size="m" align="left">Deliver outbound webhooks and events from your API, SaaS, or PaaS.</Text></Div></Div><Div flex={true} p={{
                x: 2,
                b: 2
              }}><StyledCard overflow_hidden={true} flex={{
                  align: "center",
                  justify: "center"
                }}><img src={`/images/usecase-send-${theme.mode}.png`} alt="Outpost" style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain"
                  }} /></StyledCard></Div></StyledRadioCard></Div></Div><StyledCard p={4} flex={{
          justify: "space-between"
        }}><Div m={{
            r: 4
          }}><Text semi={true}>Private project</Text><Text muted={true}>Can only be accessed by Organization Members you specify.</Text></Div><Tooltip disabled={is_admin} tooltip="Only organization admins and owners can create public projects."><SwitchInput name="private" disabled={!is_admin} /></Tooltip></StyledCard></Modal></form>;
    $[12] = is_admin;
    $[13] = onClose;
    $[14] = theme.colors.surface.base.surface;
    $[15] = theme.mode;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== onSubmit || $[18] !== t5 || $[19] !== t6) {
    t7 = <Formik initialValues={t5} validate={_temp} onSubmit={onSubmit}>{t6}</Formik>;
    $[17] = onSubmit;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default NewTeamModal;
function _temp(v_0) {
  if (!v_0.name || v_0.name.length === 0) {
    return {
      name: "Required"
    };
  }
  if (v_0.name && v_0.name.length > 40) {
    return {
      name: "Name is longer then 40 characters"
    };
  }
}